<template>
    <div>
        <hxlHeader />
        <router-view></router-view>
        <hxlFooder />
    </div>
</template>

<script>
import hxlHeader from "@/views/common/header.vue";
import hxlFooder from "@/views/common/fooder.vue";
export default {
    components: {
        hxlHeader,
        hxlFooder,
    },
    mounted(){
        // console.log(this.$router);
    }
};
</script>

<style lang="scss" scoped>
</style>